import Logo from "components/general/Logo";
import Logos from "components/general/Logos";
import Breadcrumbs from "./components/Breadcrumbs";
import UserWidget from "./components/UserWidget";
import "./top-bar.scss";

export default function TopBar({ showProfile }: {
   showProfile: () => void;
}) {
   return (
      <div className="top-bar">

         <div className="top-bar-left">
            <Logo/>
         </div>

         <div className="top-bar-main">
            <div className="top-bar-main-top"> 
               <Logos/>
            </div>

            <div className="top-bar-main-bottom">
               <Breadcrumbs/>
               <UserWidget onClick={ showProfile }/>
            </div>
         </div>
      </div>
   )
}